import {
  NumberRangeFilterPopover,
  NumberRangeFilterPopoverProps,
  NumberRangeFilterPopoverTrigger,
} from 'src/common/primitives/NumberRangeFilterPopover/NumberRangeFilterPopover';

interface InvoiceTotalDueFilterProps
  extends Omit<
    NumberRangeFilterPopoverProps,
    'triggerElement' | 'entityLabel'
  > {
  triggerElement?: NumberRangeFilterPopoverProps['triggerElement'];
}

export function InvoiceTotalDueFilter(props: InvoiceTotalDueFilterProps) {
  const hasValue = !!(
    props.value &&
    ((props.value.min && !isNaN(props.value.min)) ||
      (props.value.max && !isNaN(props.value.max)))
  );

  return (
    <NumberRangeFilterPopover
      entityLabel="Total Due"
      type="currency"
      triggerElement={
        <NumberRangeFilterPopoverTrigger
          hasValue={hasValue}
          label="Invoice Total Due"
        />
      }
      {...props}
    />
  );
}
